/** QuickRouter — Point d'entrée React */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './tokens-quickapps.css';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
